<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
@if (pageLoading || accessLoader) {
<div class="loader text-center">
	<img src="../assets/img/cc_loader.gif" />
</div>
}
@if (user_type=='cdm') {
<div class="card">
	<div class="card-header bg-primary">
		Welcome Mail
	</div>
	<div class="card-body">
		<form class="form-horizontal" [formGroup]="moduleForm" (ngSubmit)="sendMail()" #modform="ngForm">
			<div class="row">
				<div class="col">
					<label class="me-5">Vessel: <strong>{{vesselDetails?.name}}</strong></label>
					<label>Email-Id: <strong>{{vesselDetails?.email}}</strong></label>
				</div>
			</div>
			<div class="row mt-3">
				<div class="col">
					<div class="input-group input-group-sm mb-2">
						<span class="input-group-text">
							CC
						</span>
						<tag-input formControlName="cc_emails" class="form-control" id="cc_emails"
							[placeholder]="mailIdPlaceholder" [secondaryPlaceholder]="mailIdPlaceholder"
							[separatorKeys]="[' ']" [editable]="false" [validators]="emailvalidators"
							[errorMessages]="emailerrormessages" [modelAsStrings]="true" [addOnPaste]="true"
							[pasteSplitPattern]="splitPattern" [separatorKeyCodes]="[13]">
						</tag-input>
					</div>
					@if (showError('cc_emails')) {
					<p class="text-danger">
						@if (f1.cc_emails.errors?.required) {
						<span>
							Required
						</span>
						}
					</p>
					}
				</div>
			</div>
			<div class="row mt-3">
				<div class="col">
					<div class="input-group input-group-sm mb-2">
						<span class="input-group-text">
							BCC
						</span>
						<tag-input formControlName="bcc_emails" class="form-control" id="bcc_emails"
							[placeholder]="mailIdPlaceholder" [secondaryPlaceholder]="mailIdPlaceholder"
							[separatorKeys]="[' ']" [editable]="false" [validators]="emailvalidators"
							[errorMessages]="emailerrormessages" [modelAsStrings]="true" [addOnPaste]="true"
							[pasteSplitPattern]="splitPattern" [separatorKeyCodes]="[13]">
						</tag-input>
					</div>
					@if (showError('bcc_emails')) {
					<p class="text-danger">
						@if (f1.bcc_emails.errors?.required) {
						<span>
							Required
						</span>
						}
					</p>
					}
				</div>
			</div>
			<div class="row mt-3">
				<div class="col">
					<div class="input-group input-group-sm mb-2">
						<span class="input-group-text">
							Subject
							<span class="text-danger">*</span>
						</span>
						<input class="form-control" formControlName="subject" id="subject" />
					</div>
					@if (showError('subject')) {
					<p class="text-danger">
						@if (f1.subject.errors?.required) {
						<span>
							Required
						</span>
						}
					</p>
					}
				</div>
			</div>
			<div class="row mt-3">
				<div class="col">
					<!-- <div class="input-group input-group-sm mb-2">
						<span class="input-group-text">
							Body
							<span class="text-danger">*</span>
						</span>
						<textarea class="form-control" formControlName="mail_content" id="mail_content"
							style="min-height: 200px;"></textarea>
					</div> -->
					<label class="fw-bold">
						Body
						<span class="text-danger">*</span>
					</label>
					<quill-editor id="mail_content" formControlName="mail_content" class="w-100"
						[placeholder]="'Email body'" [modules]="quillConfig">
					</quill-editor>
					@if (showError('mail_content')) {
					<p class="text-danger">
						@if (f1.mail_content.errors?.required) {
						<span>
							Required
						</span>
						}
					</p>
					}
				</div>
			</div>
			<div class="row mt-3">
				<div class="col-lg-1 col-md-1 col-sm-1">
					<label class="mt-1">
						Attachments:
					</label>
				</div>
				<div class="col-lg-4 col-md-4 col-sm-4">
					<ngx-file-drop dropZoneLabel="Drop file here" browseBtnLabel="Browse file" [multiple]="true"
						(onFileDrop)="uploadFile($event)">
						<ng-template multiple="false" ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
							<div style="text-align: center;">
								<button type="button" class="btn btn-outline-primary btn-sm"
									(click)="openFileSelector()">
									Drop Or Browse file
								</button>
							</div>
						</ng-template>
					</ngx-file-drop>
				</div>
				<div class="col-lg-7 col-md-7 col-sm-7">
					<table class="table table-bordered">
						<tbody>
							<tr>
								<th colspan="3">
									{{files.length}} File{{files.length>1?'s':''}} selected
								</th>
							</tr>
							@for (att of files; track $index) {
							<tr>
								<td>{{$index+1}}</td>
								<td>{{att.name}}</td>
								<td>
									<fa-icon role="button" [icon]="['fas','times']" class="text-danger"
										(click)="removeFile($index)" matTooltip="Remove"></fa-icon>
								</td>
							</tr>
							}
						</tbody>
					</table>
				</div>
			</div>
			<!-- <div class="row mt-3">
				<div class="col-lg-1 col-md-1 col-sm-1"></div>
				<div class="col-lg-11 col-md-11 col-sm-11">
					<ng-select [items]="languages" bindLabel="name" bindValue="val" [clearable]="false"
						id="language" formControlName="language" placeholder="Language*"
						[appearance]="'outline'">
					</ng-select>
					@if (showError('language')) {
					<p class="text-danger">
						@if (f1.language.errors?.required) {
						<span>
							Required
						</span>
						}
					</p>
					}
				</div>
			</div> -->
			<div class="row mt-3">
				<div class="col-lg-1 col-md-1 col-sm-1"></div>
				<div class="col-lg-11 col-md-11 col-sm-11">
					<button type="submit" [disabled]="showMailLoader || !modform.dirty"
						class="btn btn-sm btn-outline-success">
						@if (showMailLoader) {
						<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
						}@else {
						<fa-icon [icon]="['fas', 'paper-plane']"></fa-icon>
						}
						Send
					</button>
					<a class="btn btn-sm btn-outline-dark ms-1" [routerLink]="['/app/vessel']">Cancel</a>
				</div>
			</div>
		</form>
	</div>
</div>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}